export interface AuthorizePageProps {
    state?: string;
    code: string;
    shop?: string;
}

export interface AuthCredentials {
    providerId?: ProviderId;
    userId?: string;
    userToken?: string;
    type?: string;
    finalUrl: string;
}

export interface AuthorizationState {
    state: AuthorizationStateType;
    /** i18n key for a specific message to show on the error state, if any. */
    messageKey?: string;
}

type AuthorizationStateType = "pending" | "success" | "error";

export enum ProviderId {
    Facebook = "facebook",
    Instagram = "instagram",
    Twitch = "twitch",
    Youtube = "youtube",
    Shopify = "shopify",
    StripeConnect = "stripe-connect"
}
